import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { UitkCard, UitkCardLink, UitkCardSectionSeparatorType, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkLinkButton } from 'uitk-react-button';

import { Overlay } from 'components/layout/layers/overlay';

export interface InfoModalProps {
  children?: any;
  closeA11yLabel?: string | JSX.Element;
  onClose?: () => any;
  actionComponents?: React.ReactFragment;
}

export const InfoModal: React.FunctionComponent<InfoModalProps> = props => {
  const focusRef = React.useRef(null);

  React.useEffect(() => {
    if (focusRef && focusRef.current && typeof focusRef.current.focus === 'function') {
      focusRef.current.focus();
    }
  }, []);

  const { children, closeA11yLabel, onClose, actionComponents } = props;

  const closeLabel = closeA11yLabel || <LocalizedText message="hotels.infosite.rateInfoDialog.cancelButton.a11yLabel" />;

  return (
    <Overlay type="modal" openAnimation="slideup">
      <UitkCard className="info-modal">
        <UitkCardTextSegment>
          <div ref={focusRef} tabIndex={0} className="all-y-margin-half all-x-margin-half all-y-padding-half all-x-padding-half">
            {children}
          </div>
        </UitkCardTextSegment>
        <UitkCardTextSegment className="uitk-grid all-cell-1-1" separator={UitkCardSectionSeparatorType.TOP}>
          {actionComponents || (
            <React.Fragment>
              <div className="uitk-cell uitk-type-center uitk-button-old-link">
                <strong>{closeLabel}</strong>
              </div>
              <UitkCardLink>
                <UitkLinkButton onClick={onClose} className="uitk-cell">
                  {closeLabel}
                </UitkLinkButton>
              </UitkCardLink>
            </React.Fragment>
          )}
        </UitkCardTextSegment>
      </UitkCard>
    </Overlay>
  );
};
InfoModal.displayName = 'InfoModal';
